import { computed } from '@vue/composition-api';

export default function useUserDropdownItems ({ router, store, i18n, additionalItems = [], showSupport = true } = {}) {
  router.addRoutes([
    {
      name: 'user-settings',
      path: '/user-settings',
      component: () => import('./UserSettingsRoute'),
    },
  ]);
  const items = [
    {
      name: i18n.t('My Profile'),
      routerLink: { name: 'user-settings' },
    },
    ...additionalItems,
  ];
  const isTenant = computed(() => store.getters.isTenant);
  if (isTenant.value) {
    items.push(
      {
        name: i18n.t('Back To Global Admin'),
        externalLink: `//${window.sbvrenv.PANEL_URL}/tenantLogout`,
      }
    );
  }
  if (showSupport) {
    items.push(
      {
        name: i18n.t('Support'),
        externalLink: 'https://support.springboardvr.com/',
      }
    );
  }

  return items;
}
